import { render, staticRenderFns } from "./Program.vue?vue&type=template&id=aff64606&scoped=true&"
import script from "./Program.vue?vue&type=script&lang=ts&"
export * from "./Program.vue?vue&type=script&lang=ts&"
import style0 from "./Program.vue?vue&type=style&index=0&id=aff64606&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff64606",
  null
  
)

export default component.exports